/**
 * Relative-date seeding, ported from `Services/Mock/MockDateHelper.swift`.
 *
 * Every date in the mock layer is expressed as an offset from "today" so the
 * seed never goes stale — a demo two months from now still shows a problem set
 * due in two days. Anchored to UTC midnight, matching the Swift original
 * (`Calendar.current` with the timezone forced to UTC).
 */

function utcMidnightToday(): number {
  const now = new Date();
  return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
}

/**
 * ISO8601 string for today + `offset` days at the given UTC hour/minute.
 *
 * Swift's ISO8601DateFormatter with `.withInternetDateTime` emits no fractional
 * seconds, so the milliseconds JS would add are stripped to keep both sides
 * byte-identical.
 */
export function daysFromToday(offset: number, hour = 12, minute = 0): string {
  const base = utcMidnightToday();
  const ms = base + offset * 86_400_000 + hour * 3_600_000 + minute * 60_000;
  return new Date(ms).toISOString().replace(/\.\d{3}Z$/, "Z");
}

/** Date-only shorthand, "YYYY-MM-DD". */
export function dateOnly(offset: number): string {
  return daysFromToday(offset, 0, 0).slice(0, 10);
}
